import { render, staticRenderFns } from "./ChatButtonProxy.vue?vue&type=template&id=31d75d82&scoped=true&"
import script from "./ChatButtonProxy.vue?vue&type=script&lang=ts&"
export * from "./ChatButtonProxy.vue?vue&type=script&lang=ts&"
import style0 from "./ChatButtonProxy.vue?vue&type=style&index=0&id=31d75d82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d75d82",
  null
  
)

export default component.exports